import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { UserContext } from './App';
import { StateBoxProps } from './HSM';
import model from './imgs/model.png';
// import ModalVideo from 'react-modal-video';

import HSMRenderer, {
  HSMRendererProps,
  HSMView,
  HSMViewProps,
  ToolBar,
} from './HSMRenderer.tsx';
import React from 'react';
import ModalVideo from './modalvideo.jsx';
import ModalPDF from './pdfviewer.jsx';

export type AvatarProps = {
  name: string;
  description: string;
  videos: string;
  setPlaylistOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setVideoUrl: React.Dispatch<React.SetStateAction<string>>;
  _id: string;
};

export const Avatar = ({
  name,
  description,
  videos,
  setPlaylistOpen,
  setVideoUrl,
  _id,
}: AvatarProps) => {
  const workflowsUrl = '/adls/' + _id;

  function viewWorkflows() {
    window.open(workflowsUrl, '_self');
  }

  function viewMeasurements(src) {
    // TODO pass link in as prop
    window.open(src, '_blank');
  }

  function viewVideos() {
    // TODO pass link to youtube playlist as prop
    setVideoUrl(videos);
    setPlaylistOpen(true);
    // window.open(videos, '_blank');
  }

  const WorkflowsIcon = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='-2 -2 24 24'
        width='24'
        fill='currentColor'
      >
        <path d='M2 2v4h4V2H2zm0-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm12 0h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v4h4V2h-4zm0 10h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 2v4h4v-4h-4zM2 12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 2v4h4v-4H2z'></path>
      </svg>
    );
  };

  const MeasurementsIcon = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='-2 -2 24 24'
        width='24'
        fill='currentColor'
      >
        <path d='M14.95 7.879l-.707-.707a1 1 0 0 1 1.414-1.415l.707.707 1.414-1.414-2.828-2.828L2.222 14.95l2.828 2.828 1.414-1.414L5.05 14.95a1 1 0 0 1 1.414-1.414L7.88 14.95l1.414-1.414-.707-.708A1 1 0 0 1 10 11.414l.707.707 1.414-1.414-1.414-1.414a1 1 0 0 1 1.414-1.414l1.415 1.414 1.414-1.414zM.808 13.536L13.536.808a2 2 0 0 1 2.828 0l2.828 2.828a2 2 0 0 1 0 2.828L6.464 19.192a2 2 0 0 1-2.828 0L.808 16.364a2 2 0 0 1 0-2.828z'></path>
      </svg>
    );
  };

  const VideosIcon = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='-2 -6 24 24'
        width='24'
        fill='currentColor'
      >
        <path d='M4 2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm9.98 1.605L16 1.585A2 2 0 0 1 17.414 1H18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-.586A2 2 0 0 1 16 10.414l-2.02-2.019A4 4 0 0 1 10 12H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h6a4 4 0 0 1 3.98 3.605zM17.415 9H18V3h-.586l-3 3 3 3zM5 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'></path>
      </svg>
    );
  };

  const imgSrc = './' + _id + '.png';
  const measurementsSrc = './' + _id + '.pdf';

  return (
    <div className='adl'>
      <h1>{name}</h1>
      <div className='activities'>
        <img className='avatar-model' src={imgSrc} width={200} height={250} />
        <p>{description}</p>
      </div>
      <div className='avatars-buttons'>
        <button
          className='btn btn-light'
          onClick={() => viewMeasurements(measurementsSrc)}
        >
          <div className='btn-contents'>
            <MeasurementsIcon />
            <div className='btn-text'>
              <b>Measurements</b>
            </div>
          </div>
        </button>
        <button className='btn btn-light' onClick={() => viewVideos()}>
          <div className='btn-contents'>
            <VideosIcon />
            <div className='btn-text'>
              <b>Mobility Videos</b>
            </div>
          </div>
        </button>
        <button className='btn btn-light' onClick={() => viewWorkflows()}>
          <div className='btn-contents'>
            <WorkflowsIcon />
            <div className='btn-text'>
              <b>Workflows</b>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

// let adlElts = [];
let adlElts = [];
let avatars = [];

export const Avatars = () => {
  const [avatarsLoaded, setAvatarsLoaded] = useState(false);
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');

  useEffect(() => {
    async function getAvatars() {
      avatars = [];
      const response = await fetch(`http://34.74.45.28:8080/avatars`);

      if (!response.ok) {
        const message = `An error occured: ${response.statusText}`;
        window.alert(message);
        return;
      }

      const avatarsRes = await response.json();

      avatarsRes.forEach((avatarObj) => {
        console.log(avatarObj.videos);

        avatars.push({
          name: avatarObj.name,
          _id: avatarObj._id,
          description: avatarObj.description,
          setPlaylistOpen: setPlaylistOpen,
          setVideoUrl: setVideoUrl,
          videos: avatarObj.videos,
        });
      });

      setAvatarsLoaded(true);
    }

    getAvatars();
  }, [avatarsLoaded]);

  let listItems = avatars.map((obj) => {
    return <Avatar {...obj} />;
  });

  return (
    <div className='ADLsViewer'>
      <React.Fragment>
        <ModalVideo
          channel='youtube'
          autoplay
          isOpen={playlistOpen}
          listType='playlist'
          list='PLR4mEXh9zalINkD2tpUv3dY7iy1rJkLG8'
          videoId={videoUrl}
          onClose={() => setPlaylistOpen(false)}
        />
      </React.Fragment>
      <div className='container-md mb-5'>
        <div className='row'>
          <div className='col-xl-8 offset-xl-2 col-lg-10 offset-lg-1'>
            <h1 className='header'>Avatars</h1>
          </div>
        </div>
      </div>
      {listItems}
    </div>
  );
};

export default Avatars;
